import { getSelectableProcessingActivitiesByAccessUrl, useSelectableProcessingActivitiesQuery } from "@common/hooks/useSelectableItemQueries.ts";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { useUserContext } from "../../../auth/userContextProvider/UserContextProvider.tsx";
import { SelectableItem } from "../../../processingActivity/ProcessingActivity.types";
import { useUrlProvider } from "../../../useUrlProvider.ts";
import { ProcessProcessingActivitiesFieldProps } from "./ProcessProcessingActivitiesField.tsx";

export function useProcessProcessingActivitiesField(props: ProcessProcessingActivitiesFieldProps) {
    const { permissions } = useUserContext();
    const { getProcessingActivityOverviewUrl } = useUrlProvider();
    const { isLoading, data } = useSelectableProcessingActivitiesQuery(!props.isPreview);
    // The by-access list applies the same group company rule as the processing activity page, but not its read
    // permission, so that is checked here.
    const accessibleProcessingActivitiesQuery = useDotLegalQuery<Array<SelectableItem>>(getSelectableProcessingActivitiesByAccessUrl(false), {
        enabled: !props.isPreview && permissions.processingActivityPermissions.read,
    });

    function getLinkTo(id: string) {
        const isAccessible = accessibleProcessingActivitiesQuery.data?.some((processingActivity) => processingActivity.id === id);
        return isAccessible ? getProcessingActivityOverviewUrl(id) : undefined;
    }

    return { isLoading, data, getLinkTo };
}
